import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiService from "../services/api";

export default function IdeasPage() {
    const { schoolId } = useParams();
    const navigate = useNavigate();
    const [school, setSchool] = useState(null);

    useEffect(() => {
        if (!schoolId) return;
        const load = async () => {
            try {
                const res = await apiService.getOnboardingTimeline(schoolId);
                setSchool(res.school);
            } catch {}
        };
        load();
    }, [schoolId]);

    return (
        <div style={{ background: "#fff", fontFamily: "'Baikal Book', sans-serif" }}>
            <div style={{ maxWidth: 780, width: "100%", margin: "0 auto", padding: "40px 24px 0" }}>
                {/* Back + logo */}
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
                    {schoolId && (
                        <button onClick={() => navigate(`/onboarding/${schoolId}/`)} style={{ background: "none", border: "none", cursor: "pointer", padding: 6, color: "#90A4AE", fontSize: 14, display: "flex", alignItems: "center", gap: 4, fontFamily: "'Baikal Book', sans-serif" }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8l4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                            Back
                        </button>
                    )}
                    <div style={{ flex: 1 }} />
                    {school?.image && <img src={school.image} alt={school.name} style={{ width: 32, height: 32, borderRadius: 8, objectFit: "contain" }} />}
                </div>

                <h1 style={{ fontFamily: "'Baikal Condensed', sans-serif", fontSize: 36, fontWeight: 900, marginBottom: 8 }}>Fan Access Marketplace</h1>
                <p style={{ fontFamily: "'Baikal Book', sans-serif", fontSize: 14, fontWeight: 300, opacity: 0.5, marginBottom: 24 }}>{school?.name ? `${school.name} — Revenue model` : "Revenue model — adjust the sliders to match your school"}</p>
            </div>
            <iframe
                src="/static-pages/revenue.html"
                title="Fan Access Marketplace — Revenue Model"
                style={{ width: "100%", height: 2400, border: "none" }}
            />
        </div>
    );
}
